import "@/i18n";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { AdminLayout } from "@/components/layout/AdminLayout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import PoojaList from "@/pages/PoojaList";
import PoojaDetail from "@/pages/PoojaDetail";
import KnowledgeHub from "@/pages/KnowledgeHub";
import KnowledgeArticle from "@/pages/KnowledgeArticle";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import BookingSuccess from "@/pages/BookingSuccess";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminBookings from "@/pages/admin/BookingsPage";
import AdminCalendar from "@/pages/admin/CalendarPage";
import AdminPoojas from "@/pages/admin/PoojasPage";
import AdminSettings from "@/pages/admin/SettingsPage";
import AdminReports from "@/pages/admin/ReportsPage";
import AdminUsers from "@/pages/admin/UsersPage";
import QuickAttendance from "@/pages/admin/QuickAttendance";
import GurujiDashboard from "@/pages/admin/GurujiDashboard";
import HelperDashboard from "@/pages/helper/Dashboard";

const wrapPublic = (el) => <PublicLayout>{el}</PublicLayout>;
const wrapAdmin = (el, roles = ["admin"]) => <AdminLayout allowedRoles={roles}>{el}</AdminLayout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={wrapPublic(<Home />)} />
          <Route path="/about" element={wrapPublic(<About />)} />
          <Route path="/poojas" element={wrapPublic(<PoojaList />)} />
          <Route path="/poojas/:slug" element={wrapPublic(<PoojaDetail />)} />
          <Route path="/knowledge" element={wrapPublic(<KnowledgeHub />)} />
          <Route path="/knowledge/:slug" element={wrapPublic(<KnowledgeArticle />)} />
          <Route path="/gallery" element={wrapPublic(<Gallery />)} />
          <Route path="/contact" element={wrapPublic(<Contact />)} />
          <Route path="/book" element={wrapPublic(<Booking />)} />
          <Route path="/book/success/:reference" element={wrapPublic(<BookingSuccess />)} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={wrapAdmin(<AdminDashboard />)} />
          <Route path="/admin/bookings" element={wrapAdmin(<AdminBookings />)} />
          <Route path="/admin/calendar" element={wrapAdmin(<AdminCalendar />)} />
          <Route path="/admin/poojas" element={wrapAdmin(<AdminPoojas />)} />
          <Route path="/admin/settings" element={wrapAdmin(<AdminSettings />)} />
          <Route path="/admin/reports" element={wrapAdmin(<AdminReports />)} />
          <Route path="/admin/users" element={wrapAdmin(<AdminUsers />)} />
          <Route path="/admin/quick-attendance" element={wrapAdmin(<QuickAttendance />, ["admin", "guruji"])} />
          <Route path="/admin/home" element={wrapAdmin(<GurujiDashboard />, ["guruji"])} />

          <Route path="/helper" element={wrapAdmin(<HelperDashboard />, ["helper"])} />

          <Route path="*" element={wrapPublic(<NotFound />)} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
